import React, { forwardRef, useState } from 'react'
import './ListTextArea.scss'

interface ListTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  showBullets?: boolean
  hint?: string
  error?: string
}

const ListTextarea = forwardRef<HTMLTextAreaElement, ListTextareaProps>(
  (
    {
      showBullets = false,
      hint = 'Press Enter to add another item',
      error,
      onChange,
      className = '',
      ...props
    },
    ref,
  ) => {
    const [lines, setLines] = useState<string[]>([''])

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      const value = e.target.value
      setLines(value.replace(/\r\n/g, '\n').split('\n'))

      // Let RHF handle its own onChange
      onChange?.(e)
    }

    return (
      <>
        <div className='list-textarea-wrapper'>
          {showBullets && (
            <div className='list-textarea-bullets' aria-hidden='true'>
              {lines.map((_, index) => (
                <div key={index} className='list-textarea-bullet'>
                  •
                </div>
              ))}
            </div>
          )}

          <textarea
            {...props}
            ref={ref}
            onChange={handleChange}
            className={`form-control ${showBullets ? 'list-textarea-input' : ''} ${className}`}
          />
        </div>

        <small className='text-muted d-block mt-2'>↵ {hint}</small>
        {error && <p className='text-danger'>{error}</p>}
      </>
    )
  },
)

ListTextarea.displayName = 'ListTextarea'

export default ListTextarea